import API from "..";

async function filter(url) {
  try {
    const response = await API.get(url);
    return response.data;
  } catch (e) {
    throw e.response;
  }
}

export { filter };
